import { api } from './client';
import type { TenantSummary } from './types';

export function fetchMyTenant() {
  return api<TenantSummary>('/tenant');
}

export function uploadTenantLogo(dataUrl: string) {
  return api<{ logoUrl: string }>('/tenant/logo', {
    method: 'PUT',
    body: JSON.stringify({ dataUrl }),
  });
}

export function deleteTenantLogo() {
  return api('/tenant/logo', { method: 'DELETE' });
}
